import { isEmpty } from 'lodash'

import { Markers } from '#/components/Maps/Markers/types'

/**
 * Separa marcadores válidos e inválidos baseado em suas coordenadas
 */
export function splitMarkersByCoordinates(markers?: Markers) {
  if (isEmpty(markers)) return {}

  const validMarkers: Partial<Markers> = {}
  const invalidMarkers: Partial<Markers> = {}

  for (const key in markers) {
    const arr = markers[key]

    const valids = arr?.filter(item => item.lat !== null && item.lng !== null)
    const invalids = arr?.filter(item => item.lat === null || item.lng === null)

    if (valids?.length > 0) {
      validMarkers[key] = valids as any
    }
    if (invalids?.length > 0) {
      invalidMarkers[key] = invalids as any
    }
  }

  return { invalidMarkers, validMarkers }
}
